package link.erpango.quip.domain.entities

/**
 * Marca de vehículo del catálogo (api/catalog), con sus modelos anidados.
 * Versión de dominio de `VehicleBrandDto`: los IDs se convierten a Int porque el
 * contrato de `DCompatibleVehicle` usa Int para brand_id/model_id.
 */
data class DVehicleBrand(
    val id: Int,
    val name: String,
    val models: List<DVehicleModel> = emptyList()
)

/**
 * Modelo de vehículo del catálogo (api/catalog), anidado bajo una marca.
 */
data class DVehicleModel(
    val id: Int,
    val name: String
)
